import React, { ReactNode } from "react";
import {
  ShippingCart,
  ShippingCartEntity,
} from "../shippingcart/ShippingCart.types";

export type PackableContext = {
  shippingCart: ShippingCart;
  onShippingCartUpdate: (shippingCart: ShippingCart) => void;
  searchString: string;
  onSearchStringUpdate: (searchString: string) => void;
};

export interface PackableStorageClientContextProps {
  children: ReactNode;
}

export const PackableStorageClientContext =
  React.createContext<PackableContext>({
    shippingCart: new ShippingCartEntity(),
    onShippingCartUpdate: (shippingCart: ShippingCart): void => {},
    searchString: "",
    onSearchStringUpdate(searchString) {},
  });
